module.exports = __webpack_public_path__ + "img/info2.d80b2520.png";